module.exports = __webpack_public_path__ + "1c63d1ab54ff685638eb50cc6efedd2d.svg";